const ES = navigator.language?.startsWith('es')

function findByText(text, exact = false) {
	const els = document.querySelectorAll('span, p, label, h6, .MuiTypography-root')
	for (const el of els) {
		const content = el.textContent.trim().toLowerCase()
		if (exact ? content === text.toLowerCase() : content.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}

function findByTooltip(text) {
	const els = document.querySelectorAll('[aria-label], [title]')
	for (const el of els) {
		const label = (el.getAttribute('aria-label') || el.getAttribute('title') || '').toLowerCase()
		if (label.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}


export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'chart-mixed',
		title: ES ? 'Bienvenido a Analíticas de Búsqueda' : 'Welcome to Search Analytics',
		description: ES
			? 'Este panel te ofrece un análisis detallado de la actividad de búsqueda de tu equipo. Filtra por usuario, rango de fechas y exporta datos para tus informes.'
			: 'This dashboard gives you a deep dive into search activity across your team. Filter by user, date range, and export data for reporting.',
	},
	{
		type: 'field',
		findTarget: () => document.querySelector('[data-tour-id="tour-activity-cards"]'),
		icon: 'chart-simple',
		title: ES ? 'Tarjetas de Actividad' : 'Activity Cards',
		description: ES
			? 'Métricas clave de un vistazo — búsquedas en el rango de fechas seleccionado, esta semana y este mes. Úsalas para detectar tendencias de uso rápidamente.'
			: 'Key metrics at a glance — searches in the selected date range, this week, and this month. Use these to spot usage trends quickly.',
		example: ES
			? 'Rango de fechas: 156 | Esta semana: 318 | Este mes: 1.204'
			: 'Date Range: 156 | This Week: 318 | This Month: 1,204',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Summary of searches')
			return el?.closest('.MuiGrid-item')
		},
		icon: 'table-list',
		title: ES ? 'Tabla Resumen de Búsquedas' : 'Search Summary Table',
		description: ES
			? 'Desglose detallado de búsquedas por usuario, sitio y fecha. Alterna entre vistas para analizar los datos desde diferentes perspectivas.'
			: 'Detailed breakdown of searches by user, site, and date. Toggle between views to analyze data from different perspectives.',
		example: ES
			? 'Alternar: Usuario y Sitio | Fecha y Usuario'
			: 'Toggle: User & Site | Date & User',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Number of searches by Site')
			return el?.closest('.MuiGrid-item')
		},
		icon: 'chart-pie',
		title: ES ? 'Búsquedas por Sitio' : 'Searches by Site',
		description: ES
			? 'Gráfico de donut que muestra cómo se distribuyen las búsquedas entre webs de alquiler. Identifica qué proveedores usa más tu equipo.'
			: 'Donut chart showing how searches are distributed across rental websites. Identify which providers your team uses most.',
		example: ES
			? 'PriceFly 28% | RentalSpot 22% | SwiftFleet 15%'
			: 'PriceFly 28% | RentalSpot 22% | SwiftFleet 15%',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Daily searches vs Previous Month')
			return el?.closest('.MuiGrid-item')
		},
		icon: 'chart-column',
		title: ES ? 'Comparativa Diaria de Búsquedas' : 'Daily Search Comparison',
		description: ES
			? 'Compara el volumen de búsquedas diarias con el mes anterior. Detecta patrones estacionales, picos de actividad y tendencias de productividad del equipo.'
			: 'Compare daily search volume against the previous month. Spot seasonal patterns, activity spikes, and team productivity trends.',
		example: ES
			? 'Azul = Periodo actual | Gris = Mes anterior'
			: 'Blue = Current Period | Gray = Previous Month',
	},
	{
		type: 'field',
		findTarget: () => findByTooltip('Download dashboard excel'),
		icon: 'file-excel',
		title: ES ? 'Exportar a Excel' : 'Export to Excel',
		description: ES
			? 'Descarga un informe completo en Excel con los datos del panel actual, filtrados por el rango de fechas y usuarios seleccionados.'
			: 'Download a full Excel report of the current dashboard data, filtered by your selected date range and users.',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Usa los filtros de arriba para acotar por usuario y rango de fechas. Para búsquedas competitivas en tiempo real, ve a la sección Tiempo Real en la barra lateral.'
			: 'Use the filters above to narrow down by user and date range. For real-time competitive searches, head to the Real-Time section in the sidebar.',
	},
]
